import { useNavigate } from 'react-router-dom';
import { LogOut, User as UserIcon } from 'lucide-react';
import { toast } from 'sonner';

import { Button } from '@/components/ui/button';
import { useAuthStore } from '@/stores/useAuthStore';

/**
 * Phase 5c — DropdownMenu (Radix) 클릭 안 됨 → 평면 버튼화.
 */
export function Header() {
  const user = useAuthStore((s) => s.user);
  const logout = useAuthStore((s) => s.logout);
  const navigate = useNavigate();

  if (!user) return null;

  const handleLogout = async () => {
    await logout();
    toast.success('로그아웃 됐습니다');
    navigate('/login');
  };

  return (
    <header className="flex h-14 items-center justify-between border-b bg-card px-4">
      <div className="text-sm text-muted-foreground">
        {user.orgs.length > 0
          ? user.orgs.find((o) => o.is_primary)?.name ?? user.orgs[0].name
          : '무소속'}
      </div>
      <div className="flex items-center gap-2">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate('/profile')}
          className="gap-2"
          title={user.email ?? user.name}
        >
          <UserIcon className="size-4" />
          {user.name}
        </Button>
        <Button variant="outline" size="sm" onClick={handleLogout} className="gap-2">
          <LogOut className="size-4" />
          로그아웃
        </Button>
      </div>
    </header>
  );
}
